import { makeStyles } from "@material-ui/core";
import { colors } from "../../../../shared/utils";
const useStyles = makeStyles({
  root: {
    width: "100%",
    height: "100%",
    background: colors.disabledSoft,
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    boxSizing: "border-box",
    padding: "16px",
    rowGap: "16px",
    maxHeight: "400px",
    overflow: "auto",
    scrollbarGutter: "stable", // reserve scrollbar space -> stops table width oscillation
    position: "relative",
  },
  /* Endoso 25 (HU6): la tabla de recibos no cabe en los 400px del card y
   * generaba scroll anidado (grid + card + vista). Aquí el card crece con su
   * contenido y solo queda el scroll de la página. */
  rootExpandido: {
    height: "auto", // el root del endoso mide 98vh; sin esto el card no crece
    maxHeight: "none",
    overflow: "visible",
  },
  sections: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    columnGap: "24px",
    rowGap: "32px",
    "&:last-child": { flex: 0.1, display: "flex", justifyContent: "flex-end" },
  },
  submit: {
    borderRadius: "19px",
  },
  personsContainer: {
    marginTop: "24px",
  },
  personsGrid: {
    marginTop: "8px",
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    columnGap: "16px",
    rowGap: "16px",
  },
  person: {
    background: colors.blueLighten,
    borderRadius: "19px",
    color: colors.white,
    padding: "8px",
    "&:hover": { cursor: "pointer" },
  },
  spinnerOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: colors.disabledSoft,
    zIndex: 3,
  },
});

export default useStyles;
